import React from "react";
import { TemplatesManager } from "../manager/TemplatesManager";

export const Templates: React.FC = () => {
  return (
    <div className="">  
      <TemplatesManager />
    </div>
  );
};
